import React, { useContext, useEffect, useState } from 'react'
import { ShopContext } from '../Context/ShopContext'
import { useParams } from 'react-router-dom';
import Breadcrum from '../Components/Breadcrums/Breadcrum';
import ProductDisplay from '../Components/ProductDisplay/ProductDisplay';
import DescriptionBox from '../Components/DescriptionBox/DescriptionBox';
import RelatedProducts from '../Components/RelatedProducts/RelatedProducts';
import BASE_URL from '../Config/api.js';
const Product = () => {
  const { all_product } = useContext(ShopContext);
  const { productId } = useParams();
  const [product, setProduct] = useState(null);

  useEffect(() => {
    // find in context first (fast)
    const found = all_product?.find((e) => Number(e.id) === Number(productId));
    if (found) {
      setProduct(found);
    } else {
      // fallback: fetch single product from backend
      fetch(`${BASE_URL}/product/${productId}`)
        .then(r => r.json())
        .then(res => {
          if (res.success) setProduct(res.product);
        })
        .catch(err => console.error(err));
    }
  }, [all_product, productId]);

  if (!product) return <div style={{padding:20}}>Loading product...</div>;

  return (
    <div>
      <Breadcrum product={product} />
      <ProductDisplay product={product} />
      <DescriptionBox product={product} />
      <RelatedProducts productId={product.product_id} />
    </div>
  )
}

export default Product;
